import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const StatusCards = ({ title, price }) => (
  <S.ContainerCard>
    <S.TitleCard>{title}</S.TitleCard>
    <S.ValueCard>{price.main}</S.ValueCard>
    <S.StatusContainer>
      {price.pending && (
        <p>
          Pendente: <span>{price.pending}</span>
        </p>
      )}
      {price.refused && (
        <p>
          Recusado: <span>{price.refused}</span>
        </p>
      )}
    </S.StatusContainer>
  </S.ContainerCard>
);

StatusCards.defaultProps = {
  price: {},
};

StatusCards.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.objectOf(PropTypes.string),
};

export default StatusCards;
